var React = require('react');

function LeadHot (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 84.5c-5.6 9.6-2.333 23.667 0 29.5-8.5-4-26-16-26-35s11.5-29 14-44.5c2 3.6 3.333 13.5 4 18C24.5 47 38 29.5 39.5 1 51 4 68 31.5 69 42.5c4.4-2.4 3.167-14.333 2-20 7.833 6 21.5 22 22 48.5.46 24.425-19.5 38.833-28.5 43 4-7 11.5-42-16-65.5.5 5-2.5 24-9 30.5.5-8.5-1-13.5-2.5-16-.5 3.5-3 9.5-10 21.5Z"}));
}

LeadHot.defaultProps = {"fill":"#4D4540","viewBox":"0 0 94 116"};

module.exports = LeadHot;

LeadHot.default = LeadHot;
